/**
 * Keycloak realm role names — the single source of truth for the raw role strings.
 * Nothing outside the access-level resolver/mapping should compare against these
 * directly; gate on the access-level predicates instead.
 */
export const KEYCLOAK_ROLES = {
    INTERNAL: 'internal',
    ADMIN: 'admin',
    BASIC: 'basic',
};
/**
 * Route-guard role lists, defined in one place so the set of roles that satisfies
 * each guard can be changed centrally.
 *
 *  - `ANY_INTERNAL`: any internal user (either tier). Used as the route-level *scope*
 *    check; OR-evaluated.
 *  - `INTERNAL_ADMIN`: internal scope AND admin tier. Must be evaluated as AND
 *    (e.g. `requireAllRoles` on the frontend route guard, or a handler-level
 *    `checkInternalAdminAccess` on the backend) — evaluating it as OR would wrongly
 *    admit an external admin.
 *  - `ADMIN_TIER`: admin tier on either scope — an external (company) admin OR an
 *    internal admin (i.e. the `admin` role regardless of `internal`). A single role,
 *    so it is OR-safe and mirrors the backend `checkAdminTierAccess`.
 */
export const ROUTE_ROLES = {
    ANY_INTERNAL: [KEYCLOAK_ROLES.INTERNAL],
    INTERNAL_ADMIN: [KEYCLOAK_ROLES.INTERNAL, KEYCLOAK_ROLES.ADMIN],
    ADMIN_TIER: [KEYCLOAK_ROLES.ADMIN],
};
//# sourceMappingURL=roles.js.map